<template>
    <div>
        <div class="menu-title">
            文案管理
            <!-- API Key 新手指导字典：S-API-5-2* 为 OpenRouter，S-API-5-3* 为 DeepSeek；充值教程：OpenRouter 使用 S-API-6*，DeepSeek 仅使用 S-API-7-1、S-API-7-2。修改 content/file_path 即可替换教程内容和配图。 -->
        </div>
        <div class="menu-content">
            <div>
                <el-form  :inline="true" :model="qo" size="small" class="demo-form-inline">
                  <el-form-item label="标签：">
                    <el-input v-model="qo.LIKES_label" placeholder="请输入标签" style="width: 300px"></el-input>
                  </el-form-item>
                  <el-form-item >
                    <el-button type="success" icon="el-icon-search" @click="qo.pageNo=1;queryData()">搜 索</el-button>
                  </el-form-item>
                </el-form>
            </div>
            <div style="margin: 0px 0 20px 0">
                <el-button type="primary" icon="el-icon-plus" size="small" @click="createRow()">添加</el-button>
            </div>
            <div class="table-list">
                <el-table :data="result.records" style="width: 100%" >
                    <el-table-column type="index" label="序号" width="100" ></el-table-column>
                    <el-table-column prop="label" label="标签" ></el-table-column>
                    <el-table-column prop="name" label="文案名称" ></el-table-column>
                    <el-table-column prop="content" label="文案内容" ></el-table-column>
                    <el-table-column prop="speed" label="速度" ></el-table-column>
                    <el-table-column prop="realAvatarUrl" label="图片">
                      <template slot-scope="scope" >
                        <el-image v-if="scope.row.url != null && scope.row.url.length > 0"
                                  style="width: 70px; height: 70px;background-color: #b0b4b9;"
                                  :src="path+scope.row.url"
                                  :preview-src-list="[path+scope.row.url]"
                                  fit="contain"></el-image>
                      </template>
                    </el-table-column>
                    <el-table-column label="操作" width="160">
                        <template slot-scope="scope">
                            <el-button @click.native.prevent="modifyRow(scope.row)"  type="text" size="small">
                                编辑
                            </el-button>
                            <el-button @click.native.prevent="removeRow(scope.row)"  type="text" size="small">
                                删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="page-box">
                <el-pagination background
                               @current-change="handleCurrentChange"
                               :current-page="qo.pageNo"
                               :page-size="qo.pageSize"
                               :page-sizes="[10,20,30,40,50]" @size-change="handleSizeChange" layout="total, sizes, prev, pager, next"
                               :total="result.total">
                </el-pagination>
            </div>
        </div>
        <el-dialog :close-on-click-modal="false"
                :title="dialogName"
                :visible.sync="cmdDialogVisible"
                width="40%">
            <el-form ref="cmd" label-width="80px" :rules="rules" :model="cmd">
                <el-form-item label="标签" prop="label">
                    <el-input v-model="cmd.label" placeholder="请输入标签"></el-input>
                </el-form-item>
                <el-form-item label="文案名称" prop="name">
                  <el-input v-model="cmd.name" placeholder="请输入文案名称"></el-input>
                </el-form-item>
                <el-form-item label="文案内容" prop="content">
                  <el-input v-model="cmd.content" placeholder="请输入文案内容" type="textarea"  :rows="5"></el-input>
                </el-form-item>
                <el-form-item label="速度" prop="speed">
                  <el-input v-model.number="cmd.speed" placeholder="请输入速度" >
                    <template slot="append">字数/s</template>
                  </el-input>
                </el-form-item>
                <el-form-item label="图片" >
                  <el-upload
                      class="avatar-uploader"
                      action="#"
                      :on-change="handleFileChange"
                      :auto-upload="false"
                      :show-file-list="false">
                    <img v-if="imageUrl" :src="imageUrl" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cmdDialogVisible = false"  size="small">取 消</el-button>
                <el-button type="primary" @click="submitModify"  size="small">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import request, {getFileUrl} from '@/utils/request';

    var _this;
    export default {
        name: "unitManage",
        data() {
            return {
                qo: {
                    pageNo: 1,
                    pageSize: 10,
                    LIKES_label: '',
                    DESCI_createTime:1,
                },
                result: {
                    records: [],
                    total: 0
                },
                dialogName: '编辑',
                cmdDialogVisible: false,
                cmd: {},
                rules: {
                    // label: [
                    //     {required: true, message: '请输入标签'},
                    // ],
                    // name: [
                    //   {required: true, message: '请输入文案名称'},
                    // ],
                    // content: [
                    //   {required: true, message: '请输入文案内容'},
                    // ],
                },
                imageUrl:"",
                path:getFileUrl()
            }
        },
        mounted() {
            _this = this;
            _this.queryData();
        },
        methods: {
            queryData() {
                request({
                    url: '/public/copywriting-config/query_pages',
                    method: 'post',
                    data: _this.qo
                }).then(res => {
                    _this.result.records = res.records;
                    _this.result.total = res.total;
                });
            },
            handleCurrentChange(val) {
                _this.qo.pageNo = val;
                _this.queryData();
            },
            handleSizeChange(val) {
                _this.qo.pageNo = 1;
                _this.qo.pageSize = val;
                _this.queryData();
            },
            removeRow(item) {
                _this.$confirm('此操作将永久删除记录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    request({
                        url: '/public/copywriting-config/remove/' + item.id,
                        method: 'post'
                    }).then(res => {
                        _this.$message.success("删除成功");
                        _this.queryData();
                    });
                }).catch(() => {
                });
            },
            createRow() {
                _this.dialogName = '添加';
                _this.imageUrl = ""
                _this.cmdDialogVisible = true;
                _this.$nextTick(() => {
                    _this.cmd = {
                        content: "",
                        name:"",
                        label:"",
                        url:"",
                        speed:""
                    };
                    _this.$refs.cmd.resetFields();
                });
            },
            modifyRow(item) {
                _this.dialogName = '编辑';
                _this.imageUrl = ""
                _this.cmdDialogVisible = true;
                _this.$nextTick(() => {
                    if(item.url){
                      _this.imageUrl = _this.path + item.url;
                    }else{
                      _this.imageUrl = ""
                    }
                    _this.cmd = JSON.parse(JSON.stringify(item));
                    _this.$refs.cmd.resetFields();
                });
            },
            submitModify() {
                this.$refs.cmd.validate((valid) => {
                    if (valid) {
                        if (_this.cmd.id && _this.cmd.id.toString.length > 0) {
                            request({
                                url: '/public/copywriting-config/modify',
                                method: 'post',
                                data: _this.cmd
                            }).then(res => {
                                _this.$message.success("编辑成功");
                                _this.cmdDialogVisible = false;
                                _this.queryData();
                            });
                        } else {
                            request({
                                url: '/public/copywriting-config/create',
                                method: 'post',
                                data: _this.cmd
                            }).then(res => {
                                _this.$message.success("添加成功");
                                _this.cmdDialogVisible = false;
                                _this.queryData();
                            });
                        }
                    }
                });
            },
            handleFileChange(file, fileList) {
              this.imageUrl = URL.createObjectURL(file.raw);
              let formData = new FormData();
              formData.append("file", file.raw);
              request({
                url: '/upload/file/words',
                method: 'post',
                data: formData
              }).then(res => {
                _this.$set(_this.cmd, "url", res)
              });
            },
        }
    }
</script>

<style  lang="scss">
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
